import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormGroup, FormBuilder, AbstractControl, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material';
import { Router } from '@angular/router';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { DataService } from 'src/app/blacklist/service/data.service';
import { BackendApiService } from 'src/app/service/backendapi.service';
import { EndpointsService } from 'src/app/service/endpoints.service';

@Component({
  selector: 'app-report',
  templateUrl: './report.component.html',
  styleUrls: ['./report.component.scss']
})
export class ReportComponent implements OnInit {
  @Output() refreshTableData = new EventEmitter();
  reportForm: FormGroup;
  loadPage: boolean;
  loadTable = false;
  showTable: boolean;
  reportData: [];
  updateFlag = false;
  submitted = true;

  constructor(private spinnerService: Ng4LoadingSpinnerService, private dataService: DataService,
    private formBuilder: FormBuilder, private router: Router,
    private endpointsService: EndpointsService, private dialog: MatDialog,
    private backendApiService: BackendApiService) { }

  ngOnInit(): void {
    this.spinnerService.show();
    this.createReportForm();
    this.loadPage = true;
   // this.storeAnalytics();
  }

  createReportForm() {
    this.reportForm = this.formBuilder.group({
     // msisdn: [''],
     msisdn: ['', [Validators.maxLength(12),Validators.pattern("^[0-9]*$"), this.countryCodeValidator]],
          imsi: ['']
    });
  }
  get f() {
    return this.reportForm.controls;
  }

  onSearch() {
    this.submitted = true;
    if(this.reportForm.invalid)   
    {
      return;
    }
    this.spinnerService.show();
    this.showTable = false;
    const apiUrl = this.endpointsService.URL_GET_REPORT +
      '&msisdn=' + this.reportForm.get('msisdn').value + '&userOrgId=' +
      sessionStorage.getItem('userOrgId');
    

    this.backendApiService.callToApi(apiUrl).subscribe(response =>{
      if(response === null)
        return;

      this.reportData = response;
      
      this.showTable = true;
      this.spinnerService.hide();
    });
  this.storeAnalytics();
  }
  countryCodeValidator(control: AbstractControl): { [key: string]: boolean } | null {
    if (control.value.length >= 12) {
      let map = new Map();
      map.set('Ghana', '233');
      map.set('Liberia', '231');
      map.set('Guinea Bissau', '245');
      map.set('Guinea', '224');
      map.set('Benin', '229');
      map.set('CIV', '225');
      map.set('Nigeria', '234');
      map.set('Congo-B', '242');
      map.set('Cameroon', '237');
      let v = control.value + "";
      let countryCode = v.substr(0, 3);
      let country = sessionStorage.getItem('homeCountry').trim();
      
      if (map.get(country)) {
        if (parseInt(countryCode) !== parseInt(map.get(country))) {
          return { 'countryCode': true };
        }
      }
    }
    return null;
  }
  async storeAnalytics() {
    
    const apiUrl1 = this.endpointsService.CENTRY_LOG +
      'userName=' + sessionStorage.getItem('ecowas_user_name') + '&action=Sub History' + '&module=Sub History' + '&operation=search';
    this.backendApiService.callToApi(apiUrl1).subscribe(response => {
     console.log(response);
    });

  }

}
